import { Button } from '@/components/ui/button';
import { Link } from 'react-router';

export default function HomePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-8 px-4">
      <div className="flex flex-col items-center gap-4 max-w-md text-center">
        <h1 className="text-4xl font-bold tracking-tight">Edit Engine</h1>
        <p className="text-muted-foreground text-lg">
          A better workflow for post-production.
        </p>
      </div>
      <Button asChild size="lg" className="cursor-pointer">
        <Link to="/login">Login</Link>
      </Button>
    </div>
  );
}
